/**
 * Furyu Bannerのjsonフィールドを表すクラス.
 */
export default class FuryuBannerOutputData {
    constructor(data) {
        this.bannerHtml = data;
    }
}